<template>
  <v-form
    class="bg-light py-md-3 py-1 px-3 rounded mb-1"
    @submit.prevent="submit()"
  >
    <div class="form-row">
      <div v-if="product.id" class="col-1">
        ID: {{ product.id }}
      </div>
      <div class="col-2">
        <div class="pb-0">
          <v-text-field
            v-model="product.name"
            variant="outlined"
            density="compact"
            bg-color="white"
            label="Name*"
            :error-messages="
              v$.product.name.$errors.map((e) => e.$message)
            "
            @blur="v$.product.name.$touch()"
          />
        </div>
      </div>

      <div class="col-2">
        <div class="pb-0">
          <v-text-field
            v-model="product.description"
            variant="outlined"
            density="compact"
            bg-color="white"
            label="Description"
          />
        </div>
      </div>

      <div class="col-2">
        <div class="pb-0">
          <v-text-field
            v-model="product.unit_price"
            variant="outlined"
            density="compact"
            bg-color="white"
            type="number"
            step="0.01"
            label="Price*"
            :error-messages="
              v$.product.unit_price.$errors.map((e) => e.$message)
            "
            @blur="v$.product.unit_price.$touch()"
          />
        </div>
      </div>

      <div class="col-2">
        <div class="input-group pb-0">
          <div class="input-group-prepend">
            <span class="input-group-text typeTooltip">
              <strong>Type:</strong>
              <span
                :id="'product-type-'+product.id"
                tabindex="0"
                class="option-tooltip pl-1"
              />
              <v-tooltip
                width="300px"
                activator="parent"
                location="bottom start"
                location-strategy="connected"
                class="option-tooltip"
              >
                <strong>File:</strong> there is a file associated with the product<br>
                <strong>E-Learning Course:</strong> there is a course associated with the product<br>
                <strong>Fees:</strong> default product type for any other product
              </v-tooltip>
            </span>
          </div>

          <v-select
            v-model="product.type_id"
            variant="outlined"
            density="compact"
            bg-color="white"
            class="typeSelect"
            :items="lookup.product_types"
            item-value="id"
            item-title="name"
          />
        </div>
      </div>

      <div class="col-2">
        <div class="pb-0">
          <v-text-field
            v-model="product.expiration_term"
            variant="outlined"
            density="compact"
            bg-color="white"
            label="Expiration Term*"
            type="number"
          />
        </div>
      </div>

      <div class="col-1 my-auto pb-3">
        <button
          v-if="product.id"
          type="button"
          class="btn btn-default btn-sm mr-1"
          :disabled="saveInProgress"
          @click="save"
        >
          Save <span
            v-show="saveInProgress"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </button>
        <button
          v-if="product.id"
          type="button"
          class="btn btn-default btn-sm"
          :disabled="saveInProgress"
          @click="remove"
        >
          Delete <span
            v-show="deleteInProgress"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </button>
        <button
          v-if=" ! product.id"
          type="button"
          class="btn btn-default btn-sm"
          :disabled="addInProgress"
          @click="add"
        >
          Add <span
            v-show="addInProgress"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  </v-form>
</template>

<script>
import axios from 'axios';
import { useVuelidate } from '@vuelidate/core';
import { lookup } from '../lookup/lookup';

import { appValidator } from '../../common/core/utils/validator';

export default {
  props: ['modelValue', 'index'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      lookup,
      product: { ...this.modelValue },
      saveInProgress: false,
      deleteInProgress: false,
      addInProgress: false,
    };
  },

  validations() {
    return {
      product: {
        name: {
          required: appValidator.required,
        },
        unit_price: {
          required: appValidator.required,
        },
      },
    };
  },

  methods: {

    validate() {
      let error = false;
      if (this.v$.$invalid) {
        this.v$.$touch();
        error = true;
      }

      return !error;
    },

    async save() {
      if (!this.validate()) {
        return;
      }

      this.saveInProgress = true;
      const response = await axios.put(
        `/api/products/${this.product.id}`,
        this.product,
      );
      this.saveInProgress = false;

      this.$emit('save-product', this.product);
    },

    async add() {
      if (!this.validate()) {
        return;
      }

      this.addInProgress = true;

      const response = await axios.post(
        '/api/products',
        this.product,
      );
      this.product.id = response.data.id;

      this.addInProgress = false;

      this.$emit('add-product', this.product);
    },

    async remove() {
      if (confirm('Do you really want to delete?')) {
        this.deleteInProgress = true;
        const response = await axios.delete(
          `/api/products/${this.product.id}`,
          this.product,
        );
        this.deleteInProgress = false;
        this.$emit('remove-product', this.product);
      }
    },
  },
};
</script>

<style scoped>
.typeTooltip {
    height: fit-content;
    padding: 9px 0.75rem;
}
</style>
